import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { goBackTo } from '@libs/appUrl'
import MoreIcon from '@components/Icons/MoreIcon'

const Container = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  color: white;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(3, 3, 3, 0.4) 1%,
    rgba(176, 176, 176, 0.1) 69%,
    rgba(237, 237, 237, 0) 93%,
    rgba(255, 255, 255, 0) 100%
  );
`

const Button = styled.button.attrs({ type: 'button' })`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
`

type Props = {
  isApp: boolean
  displayOptionMenu: (optionType: string) => void
  optionType?: string
}

function PostControlBox(props: Props) {
  const { displayOptionMenu, isApp, optionType } = props
  const hasOptionType = Boolean(optionType)
  const [visible, setVisible] = useState(true)

  const onClickShareButton = useCallback(() => {
    if (!displayOptionMenu) return

    displayOptionMenu(hasOptionType ? '' : 'post')
  }, [hasOptionType, displayOptionMenu])

  useEffect(() => {
    if (window.appShouldHideArticleHeader) setVisible(false)

    window.appToggleArticleOptionsMenuShowing = onClickShareButton
  }, [onClickShareButton])

  if (!visible) return null

  return (
    <Container>
      <div>
        {isApp && (
          <Button onClick={() => goBackTo()}>
            <svg width={24} height={24} viewBox="0 0 24 24">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.207 4.293a1 1 0 00-1.414 0l-7 7a1 1 0 000 1.414l7 7a1 1 0 001.414-1.414L9.914 12l6.293-6.293a1 1 0 000-1.414z"
                fill="currentColor"
              />
            </svg>
          </Button>
        )}
      </div>
      <div>
        <Button onClick={onClickShareButton}>
          <MoreIcon />
        </Button>
      </div>
    </Container>
  )
}

export default PostControlBox
